module.exports = __webpack_public_path__ + "img/instagram.168b96c8.svg";